


























































import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { NavBar, Field, CellGroup, NumberKeyboard, Button } from "vant";
import DemoBlock from "@/components/DemoBlock.vue";
import DemoSection from "@/components/DemoSection.vue";
import WeMixin from "@/components/weMixin";
import { setInterval, clearInterval } from "timers";
import api from "@/components/http/api";
import { AxiosResponse } from "axios";
import { Msg } from "@/components/http/listData";

import { CoreModule } from "@/store/modules/core";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [NumberKeyboard.name]: NumberKeyboard,
    [Button.name]: Button,
    DemoBlock,
    DemoSection,
  },
})
export default class BindUserPage extends mixins(WeMixin) {
  private model: { loginName: string; password: string; checkCode: string } = {
    loginName: "",
    password: "",
    checkCode: "",
  };
  private loading = false;

  private bindUser() {
    if (CoreModule.auth.bindUser) {
      this.$toast.fail("您已绑定用户");
      return;
    }
    if (
      this.model.checkCode.length === 0 ||
      this.model.loginName.length === 0
    ) {
      this.$toast.fail("请将信息填写完整");
      return;
    }
    this.loading = true;
    api
      .post(`/weixinmp/bindUser`, this.model, { weBindUser: false } as any)
      .then((response: AxiosResponse) => {
        const msg: Msg = response.data;
        if (msg.success) {
          CoreModule.putAuth(msg.result);
          let second = 1;
          const timer = setInterval(() => {
            second--;
            if (second) {
              // do nothing
            } else {
              clearInterval(timer);
              this.$router.replace({ name: "home" });
              this.loading = false;
            }
          }, 1000);
        } else {
          const failmsg = msg.msg + (msg.result ? "\n" + msg.result : "");
          this.$toast.fail(failmsg);
          this.loading = false;
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
